"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mailService = exports.MailService = void 0;
const axios_1 = require("axios");
const endpoints_1 = require("../config/endpoints");
class MailService {
    sendMail(type, to, name, mail, message) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const { data: result } = yield axios_1.default.post(endpoints_1.PANTON_API + '/messages', {
                    type,
                    to,
                    metadata: {
                        fullName: name,
                    },
                    from: mail,
                    message,
                });
                return result;
            }
            catch (error) {
                throw error;
            }
        });
    }
}
exports.MailService = MailService;
exports.mailService = new MailService();
